import type { User } from 'src/store';
import type { AdminLoginResponse } from './types';

import adminAxiosInstance from './axios';
import formatError from '../utils/format-error';

export interface AdminLoginPayload {
  email: string;
  password: string;
}

export async function adminLogin(payload: AdminLoginPayload): Promise<AdminLoginResponse> {
  try {
    const { data } = await adminAxiosInstance.post<AdminLoginResponse>('/admin/login', payload);
    return data;
  } catch (error) {
    throw formatError(error);
  }
}

export async function getAdminInfo(): Promise<NonNullable<User>> {
  try {
    const { data } = await adminAxiosInstance.get<{ user: NonNullable<User> }>('/admin/user-info');
    return data.user;
  } catch (error) {
    throw formatError(error);
  }
}

export async function adminLogout(): Promise<void> {
  try {
    await adminAxiosInstance.post('/admin/logout');
  } catch (error) {
    throw formatError(error);
  }
}
